import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapLocation from '../enums/MapLocation';

type logMapHeatmapTappedParams = {
  is_addition: boolean;
  map_location: MapLocation;
  trail_id?: number;
};

/**
 * User adds or removes the heatmap overlay to a map.
 * @param params - Attributes to log with the amplitude event
 * @param params.is_addition - A boolean denoting if the overlay was added as a result of the action. If false, the overlay was removed.
 * @param params.map_location - The location of the map where the interaction occurred
 * @param params.trail_id - The id of the trail
 */
const logMapHeatmapTapped = ({ is_addition, map_location, trail_id }: logMapHeatmapTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('map heatmap tapped', { 'is addition': is_addition, 'map location': map_location, 'trail id': trail_id }, callback);
};

export default logMapHeatmapTapped;
